export default theme => ({
  root: {
    visibility: 'hidden',
  },
  activated: {
    visibility: 'visible'
  }
});
